var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spin-container"},[_c('w-sys-spin',{staticClass:"loading-content",attrs:{"tip":_vm.$t('k_4c8ca400')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }